import { render, staticRenderFns } from "./AssetCategoryReg.vue?vue&type=template&id=64bab608&scoped=true&"
import script from "./AssetCategoryReg.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryReg.vue?vue&type=script&lang=js&"
import style0 from "./AssetCategoryReg.vue?vue&type=style&index=0&id=64bab608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bab608",
  null
  
)

export default component.exports